import { get, post } from "./api";
import { BillingCheckoutSessionForm } from "./NetTypes";

export async function getBillingTokenUsage(workspaceId: string) {
  const { data } = await get({
    path: `/${workspaceId}/ai/token-usage/current`,
  });
  return data;
}

export async function getBillingUserLimits() {
  const response = await get({ path: `/billing/user-limits` });
  return response.data;
}

export async function getBillingSubscriptionStatus() {
  const response = await get({ path: `/billing/subscription-status` });
  return response.data;
}

export async function getBillingPlans() {
  const response = await get({ path: `/billing/plans` });
  return response.data;
}

export const billingSetFreePlan = async (planKey: string) => {
  const response = await post({
    path: `/billing/set-free-plan`,
    data: { planKey },
  });
  return response.data;
};

export const billingCheckoutSession = async (checkoutSession: BillingCheckoutSessionForm) => {
  const response = await post({
    path: `/billing/checkout-session`,
    data: checkoutSession,
  });
  return response.data;
};

export async function getBillingAddress() {
  const response = await get({ path: `/billing/billing-address` });
  return response.data;
}

export const updateBillingAddress = async (data: any) => {
  const response = await post({
    path: `/billing/billing-address`,
    data,
  });
  return response.data;
};

export async function getBillingPaymentMethod() {
  const response = await get({ path: `/billing/payment-method` });
  return response.data;
}

export async function getBillingInvoices() {
  const response = await get({ path: `/billing/invoices` });
  return response.data;
}
